import "./Biography.css";

const PROFILE_IMAGE = "https://www.eastwest.lk/images/nahil-wijesuriya.jpg";

const maritimeRoles = [
  {
    period: "2002",
    role: "Owner and Operator",
    organization: "East West Bunker Services (Pvt) Ltd",
    title: "Bunker vessels",
    description:
      "Owned and operated the largest ship in Sri Lanka at the time, the 37,000 deadweight tanker MT Bunker 1, together with feeder tankers MT Rangiri, MT Ranveli and MT Randiya.",
  },
  {
    period: "1991",
    role: "Owner and Operator",
    organization: "Offshore Marine Services (Pvt) Ltd",
    title: "Offshore supply vessels",
    description:
      "Owned and operated the offshore supply vessels OMS 1 and OMS 2.",
  },
  {
    period: "1991",
    role: "Owner and Operator",
    organization: "Offshore Marine Services (Pvt) Ltd",
    title: "Salvage and towage vessels",
    description:
      "Owned and operated the salvage and towage tugs MT Nilgiri and MT Sigiri.",
  },
  {
    period: "1982–1986",
    role: "Owner and Operator",
    organization: "East West Clearing and Forwarding (Pvt) Ltd",
    title: "Clearing agency",
    description:
      "Owned and operated the country's largest customs clearing-house agency, with 200 wharf clerks.",
  },
  {
    period: "1980",
    role: "Owner and Operator",
    organization: "East West Containers (Pvt) Ltd",
    title: "Container freight station",
    description:
      "Owned and operated Sri Lanka's first off-port container freight station.",
  },
  {
    period: "1977",
    role: "Owner and Operator",
    organization: "East West Enterprises Ltd",
    title: "Shipping agency",
    description:
      "Established and operated a shipping agency providing a full range of shipping-related services.",
  },
];

const dockyardDuties = [
  "Managed vessel repair, conversion and refit projects from planning through delivery.",
  "Directed yard resources to meet customer requirements safely, on time and in compliance with regulations.",
  "Evaluated subcontractors and coordinated OEMs, classification societies and other third parties.",
  "Led business development and held responsibility for the yard's engineering facilities.",
];

const technicalManagerDuties = [
  "Held technical and operational responsibility for a fleet of vessels, ensuring compliance with company policies, classification requirements and statutory regulations.",
  "Maintained safe working conditions ashore and aboard, promoted environmental protection and encouraged continuous improvement among vessel personnel.",
  "Monitored maintenance, defects, breakdowns and corrective action, including superintendent inspections and third-party reports.",
  "Planned annual dry-dock schedules and budgets, prepared repair specifications and controlled expenditure during docking and major technical projects.",
  "Ensured timely renewal of classification and statutory certificates and kept vessels current with technical developments and regulatory amendments.",
  "Reviewed fleet performance, allocated work, chaired issue-resolution meetings and participated in safety committee and management reviews.",
  "Approved technical invoices, selected and supervised riding teams, coordinated subcontractors and liaised with third-party technical managers.",
  "Evaluated fleet managers with Operations, arranged additional training where required and submitted proposals for improving the management system.",
];

const businessHighlights = [
  "Invested successfully in international property and financial instruments in Singapore, the United Kingdom and the Philippines from 2000 to 2017.",
  "Owned and operated the Ceylon Continental Hotel, Sri Lanka's first five-star hotel, from 2008 to 2010; it is now The Kingsbury.",
  "Owned Weligama Hotel Properties (Pvt) Ltd, developer of a 200-room hotel operated under the Marriott International brand.",
  "Served as a director and substantial shareholder of Kandy Hotels 1964 Ltd, owner of the Queen's and Suisse hotels.",
  "Pioneered Sri Lanka's first 24-hour television channels, ETV 1 and ETV 2, later sold and operated as ETV and Swarnavahini, gaining extensive knowledge of copyright and intellectual property rights.",
  "Owned Sri Lanka's first IBM PC dealership, East West Information Systems Ltd, now operating as EWIS.",
  "Designed and built the IBM Building, the first building in Nawam Mawatha and the first in Sri Lanka with a multi-storey car park and car lift.",
  "Owned the Forbes and Walker Building at Nawam Mawatha and developed more than one million square feet of warehousing at Peliyagoda, including Sri Lanka's first multi-storey warehouses with cargo lifts.",
];

const sailingDuties = [
  "Led the engineering department and served as a permanent member of the Shipboard Management Committee.",
  "Allocated watchkeeping duties and ensured safe, efficient and economical operation of propulsion, power generation, auxiliary, cargo-handling and electrical machinery.",
  "Planned and supervised maintenance, repairs, surveys, anti-corrosion work and the vessel's planned maintenance system in compliance with class rules.",
  "Took personal charge of propulsion and engine-room systems during critical navigation, manoeuvring and bunkering operations.",
  "Maintained seaworthiness and ensured compliance with environmental, health, safety, statutory and international requirements.",
  "Diagnosed machinery faults, directed corrective action and coordinated emergency response with the Master and Emergency Response Team.",
  "Issued standing orders, established clear assignments and supervised officers, ratings, cadets, riding teams and shore contractors.",
  "Planned training, supported professional development, appraised engineering staff and upheld safe working and disciplinary standards.",
  "Controlled engineering budgets, spares, stores, bunkers, lubricants, water and consumables for reliable and economical operation.",
  "Prepared dry-docking and special-survey repair lists and maintained engine-room logs, oil record books, technical drawings and stock records.",
];

const seaService = [
  [
    "Chief Engineer",
    "Lanka Shanthi",
    "Sri Lanka",
    "General cargo",
    "9,464.36 / 5,776.33",
    "6,600 BHP",
    "03 May 1976",
    "01 Oct 1976",
    "4m 29d",
  ],
  [
    "Senior 2nd Engineer",
    "Lanka Shanthi",
    "Sri Lanka",
    "General cargo",
    "9,464.36 / 5,776.33",
    "6,600 BHP",
    "23 Mar 1976",
    "02 May 1976",
    "1m 10d",
  ],
  [
    "2nd Engineer",
    "Lanka Rani",
    "Sri Lanka",
    "General cargo",
    "10,345.22 / 5,667.88",
    "7,050 BHP",
    "24 Apr 1975",
    "28 Jul 1975",
    "3m 5d",
  ],
  [
    "2nd Engineer",
    "Lanka Rani",
    "Sri Lanka",
    "General cargo",
    "10,345.22 / 5,667.88",
    "7,050 BHP",
    "09 Sep 1974",
    "23 Apr 1975",
    "7m 15d",
  ],
  [
    "2nd Engineer Officer",
    "Lanka Kalyani",
    "Colombo",
    "General cargo",
    "5,206.56 / 2,923.39",
    "4,700 BHP",
    "31 Dec 1973",
    "27 May 1974",
    "4m 28d",
  ],
  [
    "3rd Engineer Officer",
    "M.S. Merkará",
    "London",
    "General cargo",
    "11,142.5 / 5,946.73",
    "4,700 BHP",
    "07 Jul 1973",
    "11 Dec 1973",
    "5m 5d",
  ],
];

const education = [
  [
    "1976",
    "Certificate of Competency in Marine Engineering (Class 1)",
    "United Kingdom",
  ],
  [
    "1972",
    "Training on Sulzer RND 1050 diesel engines",
    "Main Research Centre, Winterthur, Switzerland",
  ],
  [
    "1967–1971",
    "HND in Mechanical and Production Engineering",
    "Leicester College of Technology, UK",
  ],
  [
    "1964–1967",
    "Special Marine Engineering Apprentice",
    "Walker Sons & Co Ltd, Colombo Dry Docks, Mutwal",
  ],
  [
    "1962",
    "GCE Ordinary Level: five credit passes and two ordinary passes",
    "Trinity College, Kandy",
  ],
];

const contributions = [
  {
    year: "2016–2017",
    title: "Marine Engineers Trust",
    text: "Worked with the local IMarEST branch to form a trust and donate a four-storey building with an office, auditorium, library and recreation facilities for Sri Lanka's marine engineers.",
  },
  {
    year: "2000",
    title: "Office space for IMarE",
    text: "Provided an office and conference room without charge in the Nawam Mawatha Business Complex, housing the IMarE Colombo office until the building was sold.",
  },
  {
    year: "Professional service",
    title: "Marine engineering bodies",
    text: "Committee Member of the Society of Chief Engineers – Marine (Sri Lanka), and member of the Institute of Marine Engineering, Science and Technology, UK, Sri Lanka branch.",
  },
];

const csrProjects = [
  [
    "1990",
    "Old Trinitians' Sports Club",
    "Built and gifted the Old Trinitians' Sports Club at the Asgiriya Grounds, Kandy.",
  ],
  [
    "2004",
    "Beira Lake",
    "Cleaned the Beira Lake by pumping seawater at 1,000 tons per hour to displace accumulated algae to the sea.",
  ],
  [
    "2004–2005",
    "Public service",
    "Served as Chairman of the Co-operative Wholesale Establishment, which operated 150 supermarket outlets under the Ministry of Trade.",
  ],
  [
    "2006–2007",
    "School buildings",
    "Financed buildings for three schools in Hambantota that were destroyed by the tsunami.",
  ],
  [
    "2007",
    "Lakshman Kadirgamar memorial",
    "Designed and erected a statue at the Liberty Cinema roundabout in memory of the assassinated Foreign Minister and fellow Trinitian.",
  ],
];

const Section = ({ eyebrow, title, children, className = "" }) => (
  <section className={`bio-section ${className}`}>
    <div className="bio-section-heading">
      <span>{eyebrow}</span>
      <h2>{title}</h2>
    </div>
    {children}
  </section>
);

export const Biography = () => {
  return (
    <main className="biography-page">
      <header className="bio-hero">
        <div className="bio-hero-copy">
          <p className="bio-kicker">Continuous Professional Development </p>
          <h1>Nahil Wijesuriya</h1>
          <p className="bio-deck">
            Marine engineer, ship owner, entrepreneur and civic contributor. A
            professional record spanning sea service, fleet leadership, maritime
            enterprise, property, technology and public service.
          </p>
        </div>
        <figure className="bio-portrait">
          <img src={PROFILE_IMAGE} alt="Simply Nahil book cover" />
          <figcaption>Engineer · Entrepreneur · Philanthropist</figcaption>
        </figure>
      </header>

      <section className="bio-facts" aria-label="Personal details">
        <div>
          <span>Born</span>
          <strong>08 May 1945</strong>
        </div>
        <div>
          <span>Education</span>
          <strong>Trinity College Kandy</strong>
        </div>
        <div>
          <span>School years</span>
          <strong>1953–1964</strong>
        </div>
        <div>
          <span>Sport</span>
          <strong>1st XI Cricket, 1963</strong>
        </div>
      </section>

      <Section eyebrow="01 / Maritime" title="Shore-based maritime experience">
        <div className="bio-timeline">
          {maritimeRoles.map((item) => (
            <article className="bio-role" key={`${item.period}-${item.title}`}>
              <time>{item.period}</time>
              <div>
                <p className="bio-role-label">
                  {item.role} · {item.organization}
                </p>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
          <article className="bio-role bio-role-featured">
            <time>1976–1977</time>
            <div>
              <p className="bio-role-label">
                Deputy Chief Engineer · Colombo Dockyard
              </p>
              <h3>Engineering and project management</h3>
              <ul>
                {dockyardDuties.map((duty) => (
                  <li key={duty}>{duty}</li>
                ))}
              </ul>
            </div>
          </article>
          <article className="bio-role bio-role-featured">
            <time>1975–1976</time>
            <div>
              <p className="bio-role-label">
                Technical Manager · Ceylon Shipping Corporation Ltd, Sri Lanka
              </p>
              <h3>Fleet technical and operational leadership</h3>
              <ul>
                {technicalManagerDuties.map((duty) => (
                  <li key={duty}>{duty}</li>
                ))}
              </ul>
            </div>
          </article>
        </div>
        <p className="bio-reference">
          Competency record references: A1, B1–B3, C1–C4 and E1–E4.
        </p>
      </Section>

      <Section
        eyebrow="02 / Enterprise"
        title="Shore-based experience beyond maritime"
        className="bio-section-tinted"
      >
        <div className="bio-intro-row">
          <div>
            <span className="bio-date-chip">1981–2017</span>
            <h3>Founder, Chairman and Principal Shareholder</h3>
            <p>East West Properties PLC</p>
          </div>
          <p>
            Built a diverse portfolio across property, hospitality,
            broadcasting, technology, logistics and international investment.
          </p>
        </div>
        <ul className="bio-highlight-grid">
          {businessHighlights.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Section>

      <Section
        eyebrow="03 / At sea"
        title="Sailing experience at management level"
      >
        <div className="bio-intro-row">
          <div>
            <span className="bio-date-chip">1971–1977</span>
            <h3>Chief Engineer Officer / Second Engineer Officer</h3>
          </div>
          <p>
            Ceylon Shipping Corporation Ltd · British India Steam Navigation
            Company · P&amp;O Shipping Lines
          </p>
        </div>
        <ul className="bio-duty-list">
          {sailingDuties.map((duty) => (
            <li key={duty}>{duty}</li>
          ))}
        </ul>
        <div className="bio-table-wrap">
          <table>
            <caption>Recorded sea service</caption>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Vessel</th>
                <th>Flag</th>
                <th>Type</th>
                <th>GRT / NT</th>
                <th>Power</th>
                <th>Sign on</th>
                <th>Sign off</th>
                <th>Service</th>
              </tr>
            </thead>
            <tbody>
              {seaService.map((row) => (
                <tr key={`${row[0]}-${row[1]}-${row[6]}`}>
                  {row.map((cell, index) => (
                    <td key={`${cell}-${index}`}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>

      <Section
        eyebrow="04 / Qualifications"
        title="Education and professional development"
        className="bio-section-dark"
      >
        <div className="bio-education-list">
          {education.map(([year, qualification, institution]) => (
            <article key={year}>
              <time>{year}</time>
              <div>
                <h3>{qualification}</h3>
                <p>{institution}</p>
              </div>
            </article>
          ))}
        </div>
      </Section>

      <Section
        eyebrow="05 / Profession"
        title="Contribution to professional bodies"
      >
        <div className="bio-card-grid">
          {contributions.map((item) => (
            <article key={item.title}>
              <span>{item.year}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </Section>

      <Section
        eyebrow="06 / Public good"
        title="Voluntary and CSR projects"
        className="bio-section-tinted"
      >
        <div className="bio-csr-list">
          {csrProjects.map(([year, title, text]) => (
            <article key={title}>
              <time>{year}</time>
              <div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </article>
          ))}
        </div>
        <p className="bio-giving-link">
          Refer to the <a href="/giving">Giving page</a> for more information.
        </p>
      </Section>

      <footer className="bio-signoff">
        <div className="bio-footer-reference">
          <span>Main reference</span>
          <a
            href="https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/documents/Application+Ins+of+marine+Engineers+-+CPD+Nahil-+Version.docx.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Continuous Professional Development Report (PDF)
          </a>
          <p>
            I hereby certify that the above-mentioned particulars are true and
            correct to the best of my knowledge.
          </p>
        </div>
        <div>
          <span>Yours faithfully,</span>
          <strong>Nahil Wijesuriya</strong>
          <time>21 February 2017</time>
        </div>
      </footer>
    </main>
  );
};
